import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Quotes from "./pages/Quotes";
import QuoteBuilder from "./pages/QuoteBuilder";
import RoofTypes from "./pages/RoofTypes";
import Materials from "./pages/Materials";
import Pipeline from "./pages/Pipeline";
import Settings from "./pages/Settings";
import PublicQuoteViewer from "./pages/PublicQuoteViewer";
import { SharedDefs } from "./lib/roofIsoArt";

export default function App() {
  return (
    <div className="App">
      <SharedDefs />
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/q/:token" element={<PublicQuoteViewer />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="quotes/new" element={<QuoteBuilder />} />
              <Route path="quotes/:id" element={<QuoteBuilder />} />
              <Route path="roof-types" element={<RoofTypes />} />
              <Route path="materials" element={<Materials />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
